import { Card, Text } from "@clipboard-health/ui-components";
import { CardContent } from "@mui/material";
import { type Facility } from "@src/appV2/Facilities/types";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";

import { Button } from "../../components/Button";
import { SHIFT_DISCOVERY_WORKPLACE_POLICIES_MODAL_PATH } from "../../ShiftDiscovery/paths";
import { useWorkplaceModalsDataContext } from "../../ShiftDiscovery/useWorkplaceModalsDataContext";
import { WorkplaceHighlightPills } from "../Highlights/Pills";
import { useWorkplacePolicyHighlights } from "../Highlights/useWorkplacePolicyHighlights";

export interface WorkplacePoliciesCardProps {
  workplaceId: string;
  lateCancellation: Facility["lateCancellation"];
  requiresLunchBreak: Facility["requiresLunchBreak"];
  providesRestBreaks: Facility["providesRestBreaks"];
}

export function WorkplacePoliciesCard(props: WorkplacePoliciesCardProps) {
  const { workplaceId, lateCancellation, requiresLunchBreak, providesRestBreaks } = props;

  const { generateModalPath } = useWorkplaceModalsDataContext();

  const { highlights: policyHighlights, isLoading: isPolicyHighlightsLoading } =
    useWorkplacePolicyHighlights({
      workplaceId,
      lateCancellationPeriod: lateCancellation?.period ?? 0,
      lateCancellationFeeHours: lateCancellation?.feeHours ?? 0,
      requiresLunchBreak,
      providesRestBreaks,
    });

  return (
    <Card>
      <CardContent sx={{ padding: 7 }}>
        <Text semibold variant="body1" sx={{ marginBottom: 7 }}>
          Policies
        </Text>

        <WorkplaceHighlightPills
          highlights={policyHighlights}
          isLoading={isPolicyHighlightsLoading}
        />

        <Button
          fullWidth
          variant="outlined"
          size="medium"
          sx={{ marginTop: 8 }}
          href={generateModalPath(SHIFT_DISCOVERY_WORKPLACE_POLICIES_MODAL_PATH, {
            workplaceId,
          })}
          onClick={() => {
            logEvent(APP_V2_USER_EVENTS.VIEWED_WORKPLACE_RULES_PAGE, {
              workplaceId,
              trigger: "Workplace Profile Modal",
            });
          }}
        >
          View policies
        </Button>
      </CardContent>
    </Card>
  );
}
